"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSetVariantPriceData = exports.getArtSetPrice = exports.getSetDiscountPercent = exports.getArtTilePrice = exports.ART_SIZES = void 0;
const tiles_1 = require("./tiles");
const artUtils_1 = require("../utils/artUtils");
const ART_SIZE_PRICING = {
    [tiles_1.TILE_SIZES.SQUARE_8X8]: 15,
    [tiles_1.TILE_SIZES.SQUARE_12X12]: 35,
    [tiles_1.TILE_SIZES.SQUARE_20X20]: 95,
    [tiles_1.TILE_SIZES.SPLIT_24X24]: 79,
    [tiles_1.TILE_SIZES.RECTANGLE_8X11]: 23,
    [tiles_1.TILE_SIZES.RECTANGLE_12X16]: 39,
    [tiles_1.TILE_SIZES.RECTANGLE_20X27]: 99,
    [tiles_1.TILE_SIZES.RECTANGLE_27X36]: 139,
    [tiles_1.TILE_SIZES.SPLIT_24X32]: 99,
    [tiles_1.TILE_SIZES.SPLIT_27X40]: 138,
    [tiles_1.TILE_SIZES.RECTANGLE_11X8]: 23,
    [tiles_1.TILE_SIZES.RECTANGLE_16X12]: 39,
    [tiles_1.TILE_SIZES.RECTANGLE_27X20]: 99,
    [tiles_1.TILE_SIZES.RECTANGLE_36X27]: 139,
    [tiles_1.TILE_SIZES.SPLIT_32X24]: 99,
    [tiles_1.TILE_SIZES.SPLIT_40X27]: 138
};
exports.ART_SIZES = Object.keys(ART_SIZE_PRICING);
const getArtTilePrice = (tileSize) => ART_SIZE_PRICING[tileSize];
exports.getArtTilePrice = getArtTilePrice;
// Sum up the price of multiple tiles
function _getArtTilesPrice(tiles) {
    return tiles.reduce((currentSetPrice, tileData) => {
        currentSetPrice += (0, exports.getArtTilePrice)(tileData.size);
        return currentSetPrice;
    }, 0);
}
const getSetDiscountPercent = (setData) => {
    if (setData.tiles.length <= 2) {
        return 0;
    }
    else if (setData.tiles.length <= 5) {
        return 15;
    }
    else {
        return 30;
    }
};
exports.getSetDiscountPercent = getSetDiscountPercent;
// Apply discount for larger sets - for example 30% discount for sets with 6+ tiles
const getArtSetPrice = (setData) => {
    const preDiscountPrice = _getArtTilesPrice(setData.tiles);
    const discountPercent = 0; // We can use getSetDiscountPercent if we want to have discounts
    const price = Math.floor(preDiscountPrice * (100 - discountPercent) / 100);
    return {
        preDiscountPrice,
        discountPercent,
        price
    };
};
exports.getArtSetPrice = getArtSetPrice;
const getSetVariantPriceData = (setVariant) => {
    const frames = setVariant.layout.frames;
    const tiles = frames.map(frame => ({
        size: Object.values(tiles_1.TILE_SIZES).find(n => n.endsWith((0, artUtils_1.getSizeString)(frame.size)))
    }));
    return (0, exports.getArtSetPrice)({ tiles });
};
exports.getSetVariantPriceData = getSetVariantPriceData;
//# sourceMappingURL=artPricing.js.map